import { Component, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { ApiHttpService } from 'src/app/_services/api-http.service';
import { environment } from 'src/environments/environment';
const { API_URL } = environment;

@Component({
  selector: 'app-fui-india-report',
  templateUrl: './fui-india-report.component.html',
  styleUrls: ['./fui-india-report.component.scss']
})
export class FuiIndiaReportComponent implements OnInit {
  tableSelectedColumn: ColDef[]|any = [];

 
  public defaultColDef: ColDef|any = {
    flex: 1,
    minWidth: 150,
    filter: true,
    resizable: true,
    sortable:true,
    
  }
  constructor(private apiHttpService: ApiHttpService) { }
  Resultdata: any;
  ngOnInit(): void {
    let merchantdata = { "name": "" }
    this.apiHttpService
      .post(`${API_URL}/GetMerchant`, merchantdata)
      .subscribe((res) => {
        this.Resultdata = res
       
      });
  }
  
  columnDefs: ColDef[] = [
    { field: 'serialNo' },
    { field: 'zipFileName' },
    { field: 'reportDate' },
    { field: 'BRN' },
    { field: 'uploadedZip' },
    { field: 'status' },
    { field: 'batchFile' },
    { field: 'submittedBatch' },
    { field: 'merchantName' }
];

rowData = [
    { serialNo: '1', zipFileName: 'File 1', reportDate: "4:20 PM 10/08/2023",BRN:"XYZ",uploadedZip:"File1",status:"",batchFile: "File1",submittedBatch:"File1",merchantName:"Merchant1"},
    { serialNo: '2', zipFileName: 'File 2', reportDate: "4:20 PM 10/08/2023",BRN:"XYZ",uploadedZip:"File2",status:"",batchFile: "File2",submittedBatch:"File2",merchantName:"Merchant2"},
    { serialNo: '3', zipFileName: 'File 3', reportDate: "4:20 PM 10/08/2023",BRN:"XYZ",uploadedZip:"File3",status:"",batchFile: "File3",submittedBatch:"File3",merchantName:"Merchant3"},
    { serialNo: '4', zipFileName: 'File 4', reportDate: "4:20 PM 10/08/2023",BRN:"XYZ",uploadedZip:"File4",status:"",batchFile: "File4",submittedBatch:"File4",merchantName:"Merchant4"},
    { serialNo: '5', zipFileName: 'File 5', reportDate: "4:20 PM 10/08/2023",BRN:"XYZ",uploadedZip:"File5",status:"",batchFile: "File5",submittedBatch:"File5",merchantName:"Merchant5"},

];

merchantid:any;
  showhtml:boolean=false
  onSelectMerchant(event:any){
    if(event==undefined){
      this.showhtml=false
    }
    else{     
      this.merchantid=event;      
      this.showhtml=true     
    }
  }
  


}
